$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        const $nav = $(this).siblings(".js-nav");
        const isExpanded = $nav.attr("aria-expanded") === "true";
        $nav.attr("aria-expanded", !isExpanded);
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            $(".js-navbutton").removeClass("active");
            $(".js-nav").attr("aria-expanded", false);
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this).find(".js-hero-slider-track").slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-hero-slider-dots"),
                prevArrow: $(this).find(".js-hero-slider-prev"),
                nextArrow: $(this).find(".js-hero-slider-next"),
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this).find(".js-content-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-content-slider-dots"),
                prevArrow: $(this).find(".js-content-slider-prev"),
                nextArrow: $(this).find(".js-content-slider-next"),
            });

            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-content-slider-count").text(i);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        // $(this).parents(".js-accordion-wrapper")
        //     .find(".js-accordion-content")
        //     .not($content)
        //     .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState');

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        setTimeout(() => {
            sessionStorage.setItem('dialogState', true);
            $(this).parents(".js-dialog").get(0).close();
            $("body").removeClass("freeze");
        }, 400);

    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            setTimeout(() => {
                sessionStorage.setItem('dialogState', true);
                $(this).get(0).close();
                $("body").removeClass("freeze");
            }, 400);

        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }

});

const asideElementRed = $('.js-aside-button-red');
const asideElementGrey = $('.js-aside-button-grey');
const backgroundRedElements = $('.backgroundRed');
const backgroundGreyElements = $('.backgroundGrey');

function isElementOnTop(element1, element2) {
    const rect1 = element1.getBoundingClientRect();
    const rect2 = element2.getBoundingClientRect();

    const overlap = !(
        rect1.right < rect2.left ||
        rect1.left > rect2.right ||
        rect1.bottom < rect2.top ||
        rect1.top > rect2.bottom
    );

    if (overlap) {
        const zIndex1 = $(element1).css('z-index');
        const zIndex2 = $(element2).css('z-index');

        if (zIndex1 !== 'auto' && zIndex2 !== 'auto') {
            return parseInt(zIndex1, 10) > parseInt(zIndex2, 10);
        }
    }

    return false;


}


// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
    } else {
        $(".js-header").removeClass("sticky");
    }

    if (backgroundRedElements.length > 0) {
        asideElementRed.each(function () {
            let isOnTop = false;
            const asideElement = $(this);

            backgroundRedElements.each(function () {
                if (isElementOnTop(asideElement[0], this)) {
                    isOnTop = true;
                    return false; // Break the loop if one element is on top
                }
            });

            asideElement.toggleClass('colored', isOnTop);
        });
    }
    if (backgroundGreyElements.length > 0) {
        asideElementGrey.each(function () {
            let isOnTop = false;
            const asideElement = $(this);

            backgroundGreyElements.each(function () {
                if (isElementOnTop(asideElement[0], this)) {
                    isOnTop = true;
                    return false; // Break the loop if one element is on top
                }
            });

            asideElement.toggleClass('colored', isOnTop);
        });
    }
});

function openAppOrStore() {
    const button = document.querySelector('.js-app-button');
    const desktopLink = button.getAttribute('data-desktop-link');

    const appStoreScheme = "meinpraxis://";
    const playStoreScheme = "intent://#Intent;scheme=meinpraxis;package=com.monks.praxis_app.kin;end"
    const playStoreUrl = "https://play.google.com/store/apps/details?id=com.monks.praxis_app.kin";
    const appStoreUrl = "https://apps.apple.com/de/app/meine-p%C3%A4diatrische-praxis/id921469943";

    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isAndroid) {
        // Try to open Android app using Intent
        window.location.href = playStoreScheme;
    } else if (isIOS) {
        // Try to open iOS app using custom scheme
        window.location.href = appStoreScheme;
    }

    // Fallback to store if app doesn't open
    setTimeout(() => {
        if (isAndroid) window.open(playStoreUrl, '_blank');
        else if (isIOS) window.open(appStoreUrl, '_blank');
        else  window.location.href = desktopLink;
    }, 500);
}